import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0072a7",
      dark: "#003359",
      light: "#0094D7",
    },
  },
  typography: {
    fontFamily: ["Roboto", "Arial", "sans-serif"].join(","),
    fontSize: 16,
    h1: { fontSize: "30px", fontWeight: "500" },
    h2: { fontSize: "24px", fontWeight: "500" },
    h3: { fontSize: "22px", fontWeight: "500" },
    h4: {
      fontSize: "20px",
      fontWeight: "500",
    },
    h5: {
      fontSize: "18px",
      fontWeight: "500",
    },
    h6: { fontSize: "16px", fontWeight: "500" },
    body1: {
      fontSize: "16px",
    },
    body2: {
      fontSize: "14px",
    },
  },
  components: {
    MuiButton: {
      defaultProps: { disableRipple: true },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: { fontSize: 16 },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        placement: "right",
        slotProps: {
          tooltip: {
            style: {
              backgroundColor: "#0072a7",
              fontSize: "14px",
            },
          },
          arrow: {
            style: {
              color: "#0072a7",
            },
          },
        },
      },
    },
  },
});
